<div *ngIf="isLoading">
    <ng-container>
        <div class="overlay-layer bg-transparent matspinner">
            <mat-spinner></mat-spinner>
        </div>
    </ng-container>
</div>  

<div *ngIf="!isLoading" class="p-4">

    <mat-toolbar class="toolbar mat-elevation-z2" style="border-style: solid; border-width: 1px; border-color: #d5d5d5; border-radius: 10px;">
        <button mat-icon-button aria-label="Cards" (click)="onSelectListStyle(0)" matTooltip="Card-Ansicht">
            <mat-icon class="matIcon-lg" [ngClass]="{ 'theme-customer': !isList }" [ngStyle]="{'color': !isList ? '#1bc5bd' : '#969696'}">view_comfy</mat-icon>
        </button>
        <button mat-icon-button aria-label="List" (click)="onSelectListStyle(1)" matTooltip="Listen-Ansicht">
            <mat-icon class="matIcon-lg" [ngClass]="{ 'theme-customer': isList }" [ngStyle]="{'color': isList ? '#1bc5bd' : '#969696'}">list</mat-icon>
        </button>
        <span class="toolbar-spacer"></span>
        <div *ngIf="!isList">
            <button mat-icon-button aria-label="Cards" (click)="onSelectListNumberColumns(2)" matTooltip="2 Spalten" *ngIf="itemsPerRowMax > 1">
                <mat-icon class="matIcon-lg" [ngClass]="{ 'theme-customer': colClass === 'col-6' }" [ngStyle]="{'color': (colClass=='col-6') ? '#1bc5bd' : '#969696'}">looks_two</mat-icon>
            </button>
            <button mat-icon-button aria-label="Cards" (click)="onSelectListNumberColumns(3)" matTooltip="3 Spalten" *ngIf="itemsPerRowMax > 2">
                <mat-icon class="matIcon-lg" [ngClass]="{ 'theme-customer': colClass === 'col-4' }" [ngStyle]="{'color': (colClass=='col-4') ? '#1bc5bd' : '#969696'}">looks_3</mat-icon>
            </button>
            <button mat-icon-button aria-label="Cards" (click)="onSelectListNumberColumns(4)" matTooltip="4 Spalten" *ngIf="itemsPerRowMax > 3">
                <mat-icon class="matIcon-lg" [ngClass]="{ 'theme-customer': colClass === 'col-3' }" [ngStyle]="{'color': (colClass=='col-3') ? '#1bc5bd' : '#969696'}">looks_4</mat-icon>                
            </button>
            <button mat-icon-button aria-label="Cards" (click)="onSelectListNumberColumns(6)" matTooltip="6 Spalten" *ngIf="itemsPerRowMax > 4">
                <mat-icon class="matIcon-lg" [ngClass]="{ 'theme-customer': colClass === 'col-2' }" [ngStyle]="{'color': (colClass=='col-2') ? '#1bc5bd' : '#969696'}">looks_6</mat-icon>
            </button>
        </div>        
        <span class="toolbar-spacer"></span>


        <!-- AKTUELLE SORTIERUNG - AM START ARTIKELNUMMER AUFSTEIGEND -->
        <!-- <div>
            <i class="{{sortIcon}}" style="color: '#1bc5bd';"></i>
            <span class="ml-1 mr-1" style="color: '#1bc5bd'; font-size:smaller">{{sortIconText}}</span>
        </div> -->

        <div>
            <!-- <button mat-icon-button [matMenuTriggerFor]="accountMenu" aria-label="Menu for Sorting" matTooltip="Sortierung" style="text-align: end;"> -->
            <button mat-icon-button class="matToolbarBtn" [matMenuTriggerFor]="accountMenu" aria-label="Menu for Sorting" matTooltip="Sortierung" style="text-align: end;">
                <i class="{{sortIcon}}" [ngClass]="['theme-customer', sortIcon]"  style="color: '#1bc5bd';"></i>
                <span class="ml-1 mr-1 theme-customer" style="color: '#1bc5bd'; font-size:smaller">{{sortIconText}}</span>
                <!-- <mat-icon class="matIcon-lg">sort</mat-icon> -->
            </button>
        </div>
        <mat-menu #accountMenu="matMenu">
            <button mat-menu-item (click)="onSorting('nr', 'asc')">
                <i class="fas fa-sort-numeric-down"></i>
                <span class="ml-4">Artikelnummer aufsteigend</span>
            </button>
            <button mat-menu-item (click)="onSorting('nr', 'desc')">
                <i class="fas fa-sort-numeric-up"></i>
                <span class="ml-4">Artikelnummer absteigend</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="onSorting('name', 'asc')">
                <i class="fas fa-sort-alpha-down"></i>
                <span class="ml-4">Produktname aufsteigend</span>
            </button>
            <button mat-menu-item (click)="onSorting('name', 'desc')">
                <i class="fas fa-sort-alpha-up"></i>
                <span class="ml-4">Produktname absteigend</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="onSorting('bruttoPreis_E1', 'asc')">
                <i class="fas fa-sort-numeric-down"></i>
                <span class="ml-4">Preis aufsteigend</span>
            </button>
            <button mat-menu-item (click)="onSorting('bruttoPreis_E1', 'desc')">
                <i class="fas fa-sort-numeric-up"></i>
                <span class="ml-4">Preis absteigend</span>
            </button>
        </mat-menu>
    </mat-toolbar>

    <div *ngIf="!articlesfound" class="info_noarticle">Es wurden keine Artikel gefunden</div>

<!-- *ngIf="!isList"  -->

    <div class="row mt-4" style="padding-left: 10px; padding-right: 10px">
        <div *ngFor="let artikel of artikel"  class="cardframe" [ngClass]="isList ? 'islist' : colClass">

            <!-- <kkis-app-artikel-list-widget1 [artikel]=art [itemsPerRow]="itemsPerRow" [isList]="isList"></kkis-app-artikel-list-widget1> -->

            <div class="card artikelcard card-custom card-stretch gutter-b h-100 d-flex" [ngClass]="{'matrix': artikel.matrixArtikel_JN != 'N', 'islist': isList}" (click)="onOpenArtikelQuickView(artikel)">
    
                <!-- <div *ngIf="artikel.matrixArtikel_JN != 'N'">{{artikel.matrixArtikel_JN}}</div> -->

                <div class="card-body p-2 d-flex align-items-center" [ngClass]="{'islist': isList}">
                    <div class="col mt-2" align="center">
                        <img src="data:image/jpeg;base64,{{artikel.bild}}" *ngIf="artikel.bild != null" style="max-height: 30vh;" />
                        <img src="{{imgDummy}}" *ngIf="artikel.bild == null" style="max-height: 25%; max-width: 25%" />
                    </div>
                </div>

                <button mat-icon-button class="btn btn1" aria-label="Card-Basket" (click)="onAddToWarenkorb(artikel,1); $event.stopPropagation()" matTooltip="In den Warenkorb" *ngIf="artikel.matrixArtikel_JN != 'J' && artikel.kurs_JN != 'J'">
                    <i class="flaticon2-shopping-cart-1 icon-lg theme-customer-hov"></i>
                </button>

                <!-- ******************************************** -->
                <!-- TODO: ADD AS SOON AS DETAILVIEW IS ACTIVATED -->
                <!-- ******************************************** -->

                <!-- <button mat-icon-button class="btn btn2" aria-label="Card-Details" (click)="onOpenArtikelDetailView(artikel); $event.stopPropagation()" matTooltip="Detailansicht">
                    <i class="flaticon2-search-1 icon-lg"></i>
                </button> -->
                
                <div class="card-footer border-0" [ngClass]="{'islist': isList}">
                    <div class="kt1">
                        {{artikel.name}}
                    </div>
                    <div class="kt2">
                        {{artikel.name2}}
                    </div>

                    <div class="text" *ngIf="isList">
                        {{artikel.text}}
                    </div>

                    <div class="price1 mt-2" *ngIf="artikel.anzeigeNetto != null && artikel.wS_Ohneverrechnung != 1">
                        <!-- {{artikel.matrixArtikel_JN == 'N' ? 'Netto' : 'Netto ab'}} {{artikel.preisNetto | currency: 'EUR'}} -->
                        {{artikel.matrixArtikel_JN == 'N' ? 'Netto' : 'Netto ab'}} <span
                            [innerHTML]="artikel.anzeigeNetto"></span><span>&nbsp;€</span>
                    </div>
                    <div *ngIf="artikel.anzeigeBrutto != null && artikel.wS_Ohneverrechnung != 1">
                        <!-- {{artikel.matrixArtikel_JN == 'N' ? 'Brutto' : 'Brutto ab'}} {{artikel.preisBrutto | currency: 'EUR'}} -->
                        {{artikel.matrixArtikel_JN == 'N' ? 'Brutto' : 'Brutto ab'}} <span
                            [innerHTML]="artikel.anzeigeBrutto"></span><span>&nbsp;€</span>
                    </div>

                    <div class="price1 mt-2" *ngIf="artikel.wS_Ohneverrechnung == 1" style="display: flex;">
                        <div class="info"></div><span>Preis auf Anfrage!</span>
                    </div>

                    <div *ngIf="artikel.rabattfaehig_JN=='J' && artikel.rabatt != null && artikel.rabatt > 0 && artikel.preisNetto > 0">
                        <span>(inkl. {{artikel.rabatt}}% Rabatt)</span>
                    </div>
                    <div *ngIf="display_artnr==true" class="mt-2">
                        Art. Nr.: {{artikel.nr}}
                    </div>
                    <div *ngIf="artikel.artNrKunde != '' && artikel.artNrKunde != null && display_artnr==true" class="mt-2">
                        Kunden Art. Nr.: <span class="kundartnr">{{artikel.artNrKunde}}</span>
                    </div>
                    <div *ngIf="artikel.herstellerNr != '' && artikel.herstellerNr != null && display_herstellernr==true" class="mt-2">
                        Hersteller Nr.: {{artikel.herstellerNr}}
                    </div>
                    <div *ngIf="artikel.mCode1 != '' && artikel.mCode1 != null && display_mcode1==true" class="mt-2">
                        {{lbl_mcode1}}: {{artikel.mCode1}}
                    </div>
                    <div *ngIf="artikel.mCode2 != '' && artikel.mCode2 != null && display_mcode2==true" class="mt-2">
                        {{lbl_mcode2}}: {{artikel.mCode2}}
                    </div>
                </div>
    
                <div class="col" style="display: flex; justify-content: flex-end; align-items: flex-end;">
                    <div align="right" *ngIf="artikel.bestand > 0">
                        <span class="material-icons matIcon-md" style="color:#34dd34" matTooltip="Artikel auf Lager">
                            fiber_manual_record
                        </span>
                    </div>
                    <div align="right" *ngIf="artikel.bestand < 1">
                        <span class="material-icons matIcon-md" style="color:#ff0000" matTooltip="Artikel nicht auf Lager, Ware wird bestellt">
                            fiber_manual_record
                        </span>
                    </div>
                    <div align="right" *ngIf="artikel.staffelpreisVorhanden == true && artikel.festpreisNutzen != true" class="staggeredprice" title="Staffelpreis vorhanden"></div>
                </div>
            </div>

        </div>
    </div>

    <hr>

</div>

<div>
    <mat-paginator #paginator
        [length]="maxItems" 
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions" 
        [showFirstLastButtons]="true"
        [pageIndex]="page"
        (page)="getData($event)"
        aria-label="Select page">
    </mat-paginator>
</div>

